/**
 * import react
 */
import React from 'react';
import PropTypes from 'prop-types';

/**
 * import material-ui
 */
import TabelRow from '@material-ui/core/TableRow';
import TabelCell from '@material-ui/core/TableCell';
import CheckBox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

/**
 * import material-ui styles and icon
 */
import CheckCircle from '@material-ui/icons/CheckCircle';

/**
 * import helper methods
 */
import { formatTooltipProps } from './helper';

const CameraTableBodyRow = (props) => {
  const { ipAddr = '', port = '', macAddr = '' } = props;

  const handleSelectedOnclick = (e) => {
    const rIdx = parseInt(e.currentTarget.getAttribute('cameraidx'));
    if (!isNaN(rIdx)) {
      props.handleCameraListRowSelected(rIdx);
    }
  };

  const getFormatedTooltipTitle = () => {
    return (
      <>
        {
          formatTooltipProps(props)
            .map((val, idx) => {
              return (
                <Typography style={{ fontSize: '0.9rem' }} key={idx}>{val}</Typography>
              );
            })
        }
      </>
    );
  };

  return (
    <>
      <Tooltip title={getFormatedTooltipTitle()} style={{ fontSize: '1rem'}}>
        <TabelRow hover>
          <TabelCell padding="none"><CheckBox checked={props.isSelected} cameraidx={props.rIdx} onClick={handleSelectedOnclick}/></TabelCell>
          <TabelCell padding="none">
            {
              <List>
                <ListItem style={{ paddingTop: 0, paddingBottom: 0, textAlign: 'center' }} key={0}>
                  <ListItemText style={{fontSize: '1rem'}} disableTypography>{`${ipAddr}:${port}`}</ListItemText>
                </ListItem>
                <ListItem style={{ paddingTop: 0, paddingBottom: 0, textAlign: 'center' }} key={1}>
                  <ListItemText style={{fontSize: '1rem'}} disableTypography>{macAddr}</ListItemText>
                </ListItem>
              </List>
            }
          </TabelCell>
          <TabelCell padding="none" style={{ textAlign: 'center' }}>
            {props.isAssigned ? <IconButton disabled={true}><CheckCircle style={{ color: 'green' }}/></IconButton> : '-'}
          </TabelCell>
        </TabelRow>
      </Tooltip>
    </>
  );
};

export default React.memo(CameraTableBodyRow);

CameraTableBodyRow.propTypes = {
  rIdx: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  ipAddr: PropTypes.string.isRequired,
  port: PropTypes.number.isRequired,
  macAddr: PropTypes.string.isRequired,
  isAssigned: PropTypes.bool.isRequired,
  handleCameraListRowSelected: PropTypes.func.isRequired
};
